import { ShaftLengthDigit, ShaftLengthFraction, Digit, Fraction } from '@/api/models';
export interface ShaftLengthDigitFractionDto {
  shaftLengthDigitId: number;
  digit: string;
  digitId: number;
  shaftLengthFractionId: number;
  fractionName: string;
  fractionId: number;
  name: string;
}

export const createCombinedShaftLengthDigitFractionList = (
  joinTableDigits: ShaftLengthDigit[],
  joinTableFractions: ShaftLengthFraction[],
  sourceTabledigits: Digit[],
  sourceTableFractions: Fraction[],
) => {
  let shaftLengthDigitFractionList = [] as ShaftLengthDigitFractionDto[];

  let digitLen = joinTableDigits.length;
  for (let i = 0; i < digitLen; i++) {
    let shaftLengthDigitItem = joinTableDigits[i];
    let fractionLen = joinTableFractions.length;
    for (let j = 0; j < fractionLen; j++) {
      let shaftLengthFractionItem = joinTableFractions[j];
      let digit = sourceTabledigits.find((d) => d.digitId == shaftLengthDigitItem.digitId)?.name || '';
      let fractionName = sourceTableFractions.find((f) => f.fractionId == shaftLengthFractionItem.shaftLengthFractionId)?.name || '';
      shaftLengthDigitFractionList.push({
        shaftLengthDigitId: shaftLengthDigitItem.shaftLengthDigitId,
        digit: digit,
        digitId: shaftLengthDigitItem.digitId,
        shaftLengthFractionId: shaftLengthFractionItem.shaftLengthFractionId,
        fractionName: fractionName,
        fractionId: shaftLengthFractionItem.fractionId,
        name: `${digit} ${fractionName}`,
      });
    }
  }
  return shaftLengthDigitFractionList;
};
